import { Tag } from 'antd'
import {
  ELIGIBILITY_COLORS,
  ELIGIBILITY_LABELS,
  ELIGIBILITY_STATUS,
  type EligibilityStatus,
} from 'features/libra/types/eligibility'
import { Ban, Check, HelpCircle } from 'lucide-react'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const TAG_WIDTH = '6.25rem'

const StyledTag = styled(Tag)`
  width: ${TAG_WIDTH};
  display: flex;
  align-items: center;
  gap: 0.25rem;
  justify-content: space-between;
`

const niiEligibilityLabels: Record<EligibilityStatus, () => ReactNode> = {
  [ELIGIBILITY_STATUS.ELIGIBLE]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.ELIGIBLE]}>
      <Check size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.ELIGIBLE]}</span>
    </StyledTag>
  ),
  [ELIGIBILITY_STATUS.NOT_ELIGIBLE]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.NOT_ELIGIBLE]}>
      <Ban size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.NOT_ELIGIBLE]}</span>
    </StyledTag>
  ),
  [ELIGIBILITY_STATUS.UNCLEAR]: () => (
    <StyledTag color={ELIGIBILITY_COLORS[ELIGIBILITY_STATUS.UNCLEAR]}>
      <HelpCircle size={14} />
      <span>{ELIGIBILITY_LABELS[ELIGIBILITY_STATUS.UNCLEAR]}</span>
    </StyledTag>
  ),
}

export const NiiEligibilityTag: FC<{
  eligibility: EligibilityStatus | undefined
}> = ({ eligibility }) => {
  return eligibility ? niiEligibilityLabels[eligibility]() : <>-</>
}
